import AboutSection from '../components/AboutSection';

const AboutUsPage = () => <AboutSection />;

export default AboutUsPage;